import { render } from "./RemindPasswordView.vue?vue&type=template&id=772f06c8&scoped=true"
import script from "./RemindPasswordView.vue?vue&type=script&lang=js"
export * from "./RemindPasswordView.vue?vue&type=script&lang=js"

import "./RemindPasswordView.vue?vue&type=style&index=0&id=772f06c8&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772f06c8"]])

export default __exports__